import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ef-modale"
}
const _hoisted_2 = {
  key: 0,
  class: "ef-modale__header"
}
const _hoisted_3 = { class: "ef-modale__title" }
const _hoisted_4 = { class: "ef-modale__content" }

import {onMounted, watch} from 'vue';
import {storeSystem} from "@/stores/system";


export default /*#__PURE__*/_defineComponent({
  props: {
  width: { type: String, default: '30%' },
  height: { type: String, default: '50%' },
  title: { type: String, default: '' },
  open: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props



const _storeSystem = storeSystem();

watch(() => props.open, (newValue) => {
  newValue ? _storeSystem.openModale() : _storeSystem.closeModale();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (__props.open)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "ef-modale__window",
              style: _normalizeStyle(`width: ${__props.width}; height: ${__props.height};`)
            }, [
              (__props.title !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
                    _createElementVNode("i", {
                      class: "fas fa-times ef-modale__close clickable",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})